import React from 'react';
import IcQuestion from 'assets/images/backoffice/capital/ic-question-mark.svg';
import Button from '../Button';
import styles from './InfoCard.css';
import InfoCard from './InfoCard';
import ListItem from '../ListItem';

function InvestmentProcess() {
  return (
    <InfoCard
      title="Apa itu Moka Capital Investment?"
      subTitle="Moka Capital bekerja sama dengan Santara dalam memberikan fasilitas pendanaan modal dengan sistem equity crowdfunding yang ditujukan untuk pengembangan bisnis."
      icon={<img src={IcQuestion} className={styles.question} />}
    >
      <div className={styles['fast-loan-process']}>
        <p className={`${styles.title} ${styles['title-content']}`}>
          Alur Penerimaan Pendanaan
        </p>
        <ListItem color="green" number={1}>
          Waktu review setelah melengkapi data diri (± 7 hari kerja)
        </ListItem>
        <ListItem color="green" number={2}>
          Waktu penyusunan kesepakatan (± 2 hari kerja)
        </ListItem>
        <ListItem color="green" number={3}>
          Waktu media promosi dan prospektus (± 2 hari kerja)
        </ListItem>
        <ListItem color="green" number={4}>
          Masa penawaran saham (Maks. 60 hari kerja)
        </ListItem>
        <ListItem color="green" number={5} last>
          Penyerahan dana (Maks. 21 hari kerja)
        </ListItem>
        <div className={styles['fast-loan-action']}>
          <Button
            title="Baca FAQ"
            btnType="outline"
            href="https://mokaposhelp.zendesk.com/hc/en-us/sections/360003335313-Moka-Capital"
            target="_blank"
          />
        </div>
      </div>
    </InfoCard>
  );
}

export default InvestmentProcess;
